<template>
    <div>
        <div class="elementary-section">
            <div class="elementary-section__in">
                <accessory-type-list v-if="accessoriesTypes.length"/>

                <div class="container">
                    <div class="info" v-if="accessoriesTypes.length === 0">
                        <p class="info-text">Váš projekt neobsahuje žádné příslušenství.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AccessoryTypeList from '@/modules/ProjectModule/modules/OptionModule/components/Accessory/AccessoryTypeList';

export default {
    name:       'AccessoryTypeContainer',
    components: {
        AccessoryTypeList
    },
    computed:   {
        accessoriesTypes() {
            return this.$store.getters['projects/project/accessory/accessoriesOwnOrFilled'];
        }
    }
}
</script>
